import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Subscription} from '../../order/models/order-form';

export const subscriptionActionTypes = {
  LOAD: type('[subscription] Load'),
  LOAD_SUCCESS: type('[subscription] Load Success'),
  LOAD_FAIL: type('[subscription] Load Fail'),
  CLEAR: type('[subscription] Clear'),
};

export class LoadSubscriptionAction implements Action {
  readonly type = subscriptionActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadSubscriptionSuccessAction implements Action {
  readonly type = subscriptionActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class LoadSubscriptionFailAction implements Action {
  readonly type = subscriptionActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SubscriptionClearAction implements Action {
  readonly type = subscriptionActionTypes.CLEAR;
  constructor() {}
}

